module.exports = __webpack_public_path__ + "img/ennetix-application-detail-page-network-tab3.13daf6af.png";